import React from 'react';
import './CardWide.scss';
import { IoIosArrowForward } from 'react-icons/io';
import checked from './../../assets/svgs/checkedLW.svg';

type Props = {
  orderNumber: string;
  date: string;
  checkedAlt: string;
};

const CardWide = (props: Props) => {
  const {
    orderNumber = '',
    date = '',
    checkedAlt = '',
  } = props;
  return (
  <div className="card-wide">
    <div className="card-wide__content">
      <div className="card-wide__header">
        <div className="card-wide__header__check">
          <img src={checked} alt={checkedAlt}/>
        </div>
        <div className="card-wide__header__title">
          <h1>Order Number: {orderNumber}</h1>
        </div>
      </div>
      <div className="card-wide__footer">
        <div className="card-wide__footer__date">
          <p>Date Ordered: {date}</p>
        </div>
        <div className="card-wide__footer__status">
          <p>&nbsp;</p>
        </div>
        <IoIosArrowForward style={{ color: '#E26329' }} onClick={()=> ('')}/>
      </div>
    </div>
  </div>
  );
};

export default CardWide;
